import React from "react";
import Button from "../../buttons/Button";
import Translate from "localization/Translate";

export default function cancelButton({theme, onClick, shouldCancelTransaction, title}) {
    if(theme === 'Erply'){
        return (
            <div onClick={onClick} style={{
                marginTop: '0.71rem',
                marginRight: '0.71rem',
                float: 'right'
            }}>
                <Button type="button"
                        className={"mediumEqualButton transparentButton uppercaseText"}
                        name={<Translate id={title}/>}
                        arrow="left"
                />
            </div>
        );
    }else {
        let colorClass;
        let flencheColorClass;
        if(shouldCancelTransaction){
            colorClass = 'grayButton';
            flencheColorClass = 'grayFlenche';
        }else{
            colorClass = 'blueButton';
            flencheColorClass = 'blueFlenche'
        }
        return (
            <div onClick={onClick} style={{
                marginTop: '0.71rem',
                marginRight: '0.71rem',
                float: 'right'
            }}>
                <Button type="button"
                        className={`mediumButton ${colorClass}`}
                        name={<Translate id={title}/>}
                        arrow="left"
                        flencheClass={`flencheSmallLeftBottom ${flencheColorClass}`}
                />
            </div>
        );
    }
}
